import { forwardRef, FunctionComponent, Ref } from 'react';
import styled, { css } from 'styled-components';

import { ForwardProps } from '../../types';
import { defaultThemeProp } from '../../theme';
import Flex from '../Flex';

const StyledDockedModals = styled.div(({ theme }) => {
  return css`
    position: fixed;
    z-index: ${theme.base['z-index'].modal};
    bottom: 0;
    right: 0;

    /* Allows docked modals to have consistent width, but they should probably be refactored. */
    width: 100%;
  `;
});

StyledDockedModals.defaultProps = defaultThemeProp;

const DockedModals: FunctionComponent<any & ForwardProps> = forwardRef(
  (props, ref: Ref<HTMLDivElement>) => {
    return (
      <Flex
        container={{ justify: 'end', alignItems: 'end', gap: 2, pad: [0, 2] }}
        as={StyledDockedModals}
        {...props}
        ref={ref}
      />
    );
  }
);

export default DockedModals;
